/* eslint-disable no-undef */
export default {
	name: "customer-select-for-order",
	props: ["orderTypeId", "clearSearch"],
	emits: ["customerSelected"],
	data() {
		return {
			customers: [],
			customerHeadings: [
				{
					text: "Customer #",
					field: "companyId"
				},
				{
					text: "Customer Code",
					field: "customerCode"
				},
				{
					text: "Name",
					field: "registeredCompanyName"
				},
				// {
				// 	text: "ERP Customer Code",
				// 	field: "erpCompanyCode"
				// },
				// {
				// 	text: "VAT Number",
				// 	field: "taxVatNumber"
				// }
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		getCustomers(){
			let deliveryCustomers = null;
			let collectionCustomers = null;
			let exTankCustomers = null;
			if(this.orderTypeId === orderHelper.orderType.collection) {
				collectionCustomers = true;
			}
			if(this.orderTypeId === orderHelper.orderType.delivery) {
				deliveryCustomers = true;
			}
			if(this.orderTypeId === orderHelper.orderType.exTank) {
				exTankCustomers = true;
			}
			let request = {
				isActive: true,
				searchQuery: this.filter.customerSearchQuery,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize,
				isCollectionCompany: collectionCustomers,
				isDeliveryCompany: deliveryCustomers,
				isExTankCompany: exTankCustomers
			};
			customerService.getCompanies(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.customers = successResponse.data.result;
						this.pagingDetails.pageNumber = successResponse.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = successResponse.data.pagingInfo.totalPages;
						for(let i = 0; i < this.customers.length; i++) {
							this.customers[i].selected = false;
						}
						this.customers = dataTableHelper.castFieldValues(this.customers);
                        console.log("customers", this.customers);
					}
				},
				errorResponse => {
					console.log("error", errorResponse);
					this.loading = false;
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
				}
			);
		},
		onFilterSearchClicked(){
			//TODO: pass filter values to api
			console.log("search clicked");
			this.pagingDetails = {
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			};
			this.getCustomers()
		},
        showSelectButton(suspended){
            console.log("showSelectButton", suspended);
            return suspended !== "Yes";
        },
		onCustomerSelect(companyId){
			let selectedCustomerId = companyId;
			for(let i = 0; i < this.customers.length; i++) {
				this.customers[i].selected = this.customers[i].companyId === companyId;
			}
			let selectedCustomer = this.getSelectedCompany(selectedCustomerId);
			this.filter = {
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			};
			this.$emit("customerSelected", selectedCustomer);
		},
		getSelectedCompany(companyId){
			for(let i = 0; this.customers.length; i++){
				if(this.customers[i].companyId === companyId){
					return this.customers[i];
				}
			}
			return null;
		},
		onPagingUpdated(pagingInfo){
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getCustomers();
		}
	},
	mounted: function () {
        //this.getCustomers();
	},
	watch:{
		orderTypeId:{
			handler: function () {
				if (this.orderTypeId !== null && this.orderTypeId > 0) {
					this.getCustomers();
				}
			},
			immediate: true,
			deep: true
		},
		clearSearch:{
			handler: function () {
				console.log("clearSearch", this.clearSearch);
				if(this.clearSearch){
					this.filter = {
						searchQuery: null,
						customerSearchQuery: null,
						activeOrInactiveItems: 1
					};
					this.getCustomers();
				}
			},
			immediate: true,
			deep: true
		}
	}
};
